import { render, staticRenderFns } from "./NbaNews.vue?vue&type=template&id=5fcadc86&scoped=true"
import script from "./NbaNews.vue?vue&type=script&lang=js"
export * from "./NbaNews.vue?vue&type=script&lang=js"
import style0 from "./NbaNews.vue?vue&type=style&index=0&id=5fcadc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcadc86",
  null
  
)

export default component.exports